<template>
  <form-row
    :label="label"
    :label-for="inputId"
    :error-message="errorMessage"
    :class="rowClasses"
  >
    <input
      :id="inputId"
      ref="input"
      :type="type"
      class="uk-width-1-1"
      :class="{'input--error': errorMessage}"
      :name="name"
      :value="value"
      v-bind="inputAttrs"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @keydown="$emit('keydown', $event)"
    >
    <template #label>
      <slot name="label" />
    </template>
  </form-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import formRow from './form-row.vue';

@Component({
  components: {
    'form-row': formRow
  }
})
export default class InputRow extends Vue {
  @Prop() readonly label!: string;
  @Prop() readonly name!: string;
  @Prop() readonly value!: string;
  @Prop({ default: 'text' }) readonly type!: string;
  @Prop({ default: '' }) readonly id!: string;
  @Prop({ default: '' }) readonly placeholder!: string;
  @Prop() readonly errorMessage!: string;
  @Prop() readonly inputAttrs!: { [propName: string]: unknown }
  @Prop({default: ''}) rowClasses!: string;
  @Prop({default: false}) disabled!: boolean;

  get inputId(): string {
    return this.id !== '' ? this.id : 'i' + (this as any)._uid;
  }
}
</script>

<style scoped>
.input--error {
  border-color: #d85030 !important;
}
</style>
